import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const UsersCreate: React.FC<IResourceComponentsProps> = () => {
  return <AntdInferencer />;
};
